import React, {useEffect} from 'react';
import {GlobalNavbar, Sidebar} from "./Headers";
import {LoginSidebar} from "../user";
import { useLocation } from 'react-router-dom';
import {Navgationbar} from "./index";
import $ from 'jquery'
import HSUnfold from "../HS/HSUnfold";
import HSShowAnimation from "../HS/HSShowAnimation";


const Header = ({onPageChange}) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const hideNavbar = ['/', '/home', '/notice', '/aboutUs', '/usageTerms', '/privacyPolicy', '/boardDetail'].includes(currentPath);

    useEffect(() => {
        HSUnfold.init($('[data-unfold-target]'))
        HSShowAnimation.init('.js-animation-link');
    }, []);

    return (
        <>
            <div id="header-wrapper" className="header-wrapper">
                <div className="u-sidebar-bg-overlay"
                     style={{backgroundColor: "rgba(0, 0, 0, 0.7)", display: "none"}}></div>
                <header id="site-header" className="site-header__v1 bg-white">
                    <GlobalNavbar onPageChange={onPageChange}/>
                    {!hideNavbar && <Navgationbar pageName={currentPath}/>}
                    <Sidebar onPageChange={onPageChange}/>
                    <LoginSidebar onPageChange={onPageChange}/>
                </header>
            </div>

        </>
    );
};

export default Header;